import { BrowserRouter, Routes, Route } from 'react-router-dom';
import VerificationFlow from './VerificationFlow';
import NotFoundPage from './pages/NotFoundPage';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/v/:token" element={<VerificationFlow />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}
